export default function XML_Validator() {
  return (
    <div>
      <h1>XML_Validator</h1>
      <p>This is the XML_Validator component.</p>
    </div>
  );
}